import * as React from 'react';
import {Component} from 'react';
import {Tab} from 'semantic-ui-react';
import {observer} from 'mobx-react';
import TreeSelect from 'rc-tree-select';
import 'rc-tree-select/assets/index.css';
import {getGeneratorMsg, generatorMessages} from '../../../../constants/TextConst';

@observer
class GeneratorActions extends Component<any, any> {
    editEngMessage;
    cursorPosition;

    constructor(props) {
        super(props);
        this.state = {
            message: props.field.message,
            engmessage: props.field.engmessage,
            open: false
        };
        // if the basiclang === 1 then the installation is English and there is no Hebrew
        this.editEngMessage = props.sysBasicLang === 1 ? false : props.sysCurrLang === 1;
        this.cursorPosition = 0;
        this.handleCursorPosition = this.handleCursorPosition.bind(this);
        this.handleMessageChange = this.handleMessageChange.bind(this);
        this.handleEngMessageChange = this.handleEngMessageChange.bind(this);
        this.addFieldToMessage = this.addFieldToMessage.bind(this);
        this.handleClickTab = this.handleClickTab.bind(this);
        this.openModal = this.openModal.bind(this);
    }

    handleMessageChange(e, message?) {
        const {field} = this.props;
        this.setState({
            message: message
                ? field.message.substring(0, this.cursorPosition) +
                  message +
                  field.message.substring(this.cursorPosition)
                : e.target.value
        });
        field.message = message
            ? field.message.substring(0, this.cursorPosition) +
              message +
              field.message.substring(this.cursorPosition)
            : e.target.value;
        if (message) {
            this.cursorPosition += message.length;
        }
    }

    handleEngMessageChange(e, engMessage?) {
        const {field} = this.props;
        this.setState({
            engmessage: engMessage
                ? field.engmessage.substring(0, this.cursorPosition) +
                  engMessage +
                  field.engmessage.substring(this.cursorPosition)
                : e.target.value
        });
        field.engmessage = engMessage
            ? field.engmessage.substring(0, this.cursorPosition) +
              engMessage +
              field.engmessage.substring(this.cursorPosition)
            : e.target.value;
        if (engMessage) {
            this.cursorPosition += engMessage.length;
        }
    }

    handleCursorPosition(e) {
        this.cursorPosition = e.target.selectionStart;
    }

    addFieldToMessage(value, arrayValue, eventNode) {
        const shownValue = eventNode.triggerNode.props.fullTitle;
        if (this.editEngMessage) {
            this.handleEngMessageChange(null, '<<' + shownValue + '>>');
        } else {
            this.handleMessageChange(null, '<<' + shownValue + '>>');
        }

        this.setState({open: false});
    }

    openModal() {
        this.setState({open: true});
    }

    handleClickTab(e) {
        if (!e.target.classList.contains('active') && e.target.classList.contains('item')) {
            this.editEngMessage = !this.editEngMessage;
        }
    }

    getChildData(children) {
        const data: any = [];

        for (const key in children) {
            if (children.hasOwnProperty(key)) {
                const item = children[key];
                data.push({
                    title: item.label,
                    value: item.id + '',
                    key: item.title + key + '',
                    fullTitle: item.title,
                    disabled: false
                });
            }
        }

        return data;
    }

    getData() {
        const {reportsToShow} = this.props;
        const listData: any = [];

        for (const key in reportsToShow) {
            if (reportsToShow.hasOwnProperty(key)) {
                const item = reportsToShow[key];

                listData.push({
                    title: item.label,
                    value: item.id + '',
                    key: key,
                    fullTitle: item.title,
                    disabled: true,
                    children: this.getChildData(item.children)
                });
            }
        }

        return listData;
    }

    onDropDownOpen() {
        // This should be only a temporary workaround for scrollbar opens on bottom issue.
        setTimeout(() => {
            const treeDropDown = document.getElementsByClassName('rc-tree-select-dropdown')[0];
            if (treeDropDown) {
                treeDropDown.scrollTop = 0;
            }
        }, 100);
    }

    renderValuesTreeSelect() {
        return (
            <div className="tree-select">
                <TreeSelect
                    className="general-actions-tree"
                    dropdownClassName="general-actions-tree-dropdown"
                    style={{width: 180}}
                    transitionName="rc-tree-select-dropdown-slide-up"
                    choiceTransitionName="rc-tree-select-selection__choice-zoom"
                    dropdownStyle={{maxHeight: 200, overflow: 'auto'}}
                    placeholder={getGeneratorMsg(generatorMessages.addFieldMsgText)}
                    onDropdownVisibleChange={this.onDropDownOpen}
                    searchPlaceholder={getGeneratorMsg(generatorMessages.searchMsgText)}
                    showSearch
                    allowClear
                    treeLine
                    value={getGeneratorMsg(generatorMessages.addFieldMsgText)}
                    treeData={this.getData()}
                    treeNodeFilterProp="title"
                    filterTreeNode={false}
                    onChange={this.addFieldToMessage}
                />
            </div>
        );
    }

    render() {
        const {sysCurrLang, sysBasicLang, field} = this.props;
        const panes =
            sysBasicLang === 0
                ? [
                      {
                          menuItem: {
                              key: 'heb',
                              content: getGeneratorMsg(generatorMessages.hebrewTabText)
                          },
                          render: () => (
                              <Tab.Pane>
                                  <textarea
                                      className="input-area rtl"
                                      placeholder={getGeneratorMsg(generatorMessages.hebrewTabText)}
                                      value={field.message}
                                      onChange={this.handleMessageChange}
                                      dir="rtl"
                                      onKeyUp={this.handleCursorPosition}
                                      onClick={this.handleCursorPosition}
                                  />
                              </Tab.Pane>
                          )
                      },
                      {
                          menuItem: {
                              key: 'eng',
                              content: getGeneratorMsg(generatorMessages.englishTabText)
                          },
                          render: () => (
                              <Tab.Pane>
                                  <textarea
                                      className="input-area ltr"
                                      placeholder={getGeneratorMsg(
                                          generatorMessages.englishTabText
                                      )}
                                      value={field.engmessage}
                                      onChange={this.handleEngMessageChange}
                                      dir="ltr"
                                      onKeyUp={this.handleCursorPosition}
                                      onClick={this.handleCursorPosition}
                                  />
                              </Tab.Pane>
                          )
                      }
                  ]
                : [
                      {
                          menuItem: {
                              key: 'eng',
                              content: getGeneratorMsg(generatorMessages.englishTabText)
                          },
                          render: () => (
                              <Tab.Pane>
                                  <textarea
                                      className="input-area ltr"
                                      placeholder={getGeneratorMsg(
                                          generatorMessages.englishTabText
                                      )}
                                      value={field.message}
                                      onChange={this.handleMessageChange}
                                      dir="ltr"
                                      onKeyUp={this.handleCursorPosition}
                                      onClick={this.handleCursorPosition}
                                  />
                              </Tab.Pane>
                          )
                      }
                  ];
        return (
            <div className="actions-panel-area">
                <span>{getGeneratorMsg(generatorMessages.actionPanelTitleText)}</span>
                <Tab
                    className="tab-panes"
                    panes={panes}
                    onClick={this.handleClickTab}
                    defaultActiveIndex={sysBasicLang === 1 ? 0 : sysCurrLang === 1 ? 1 : 0}
                />
                {this.renderValuesTreeSelect()}
            </div>
        );
    }
}

export default GeneratorActions;
